import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

const CSS_PREFIX = 'LearnTableau';
export namespace LearnTableauStyles {

  export const link = cssClass(CSS_PREFIX, 'link', {
    fontWeight: 'bold',
    color: applyColor(DesignTokens.color.link.standalone.default.default, CommonStyles.Colors.HyperlinkBlue),
    fontSize: 14,
  });

  export const text = cssClass(CSS_PREFIX, 'Text', {
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '21px',
    color: applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.Grey51),
    paddingLeft: '12px'
  });

  export const banner = cssClass(CSS_PREFIX, 'Banner', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, CommonStyles.Colors.Grey250),
    height: 44,
    verticalAlign: 'middle',
    display: 'flex',
    width: '100%'
  });

  export const arrow = cssClass(CSS_PREFIX, 'Arrow', {
    fill: applyColor(DesignTokens.color.link.inline.default.active, CommonStyles.Colors.HyperlinkBlue),
    height: '1.2em',
    width: '1.2em',
    display: 'inline-block',
    position: 'relative',
    top: '4px'
  });
}
